const container = document.getElementById('app-root');
const staticUrl = container.dataset.staticurl;
__webpack_public_path__ = `${staticUrl}bundles/`; // eslint-disable-line no-undef, camelcase
